"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactVirtuoso = require("react-virtuoso");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _JumpToLatestButton = require("@common/components/chat/JumpToLatestButton");
var _scrollbar = require("../../styles/scrollbar");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children"];
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var StyledScroller = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), _scrollbar.customScrollbar);
var FOOTER_HEIGHT = 30;
var AT_BOTTOM_THRESHOLD = 10;
var CARDS_KEPT_DRAWN_BEYOND_VIEW_PX = 2000;
var Scroller = /*#__PURE__*/(0, _react.forwardRef)(function Scroller(props, ref) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledScroller, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});
function ItemWrapper(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    style: _objectSpread(_objectSpread({}, props.style || {}), {}, {
      overflow: "hidden",
      paddingBottom: 8,
      paddingInline: "var(--ring-width-ring-1)"
    }),
    "data-sentry-component": "ItemWrapper",
    "data-sentry-source-file": "VirtualizedMessageList.tsx",
    children: children
  }));
}
function Footer(_ref2) {
  var _context$bottomInset;
  var context = _ref2.context;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      height: FOOTER_HEIGHT + ((_context$bottomInset = context === null || context === void 0 ? void 0 : context.bottomInset) !== null && _context$bottomInset !== void 0 ? _context$bottomInset : 0)
    },
    "data-sentry-component": "Footer",
    "data-sentry-source-file": "VirtualizedMessageList.tsx"
  });
}
function VirtualizedMessageList(_ref3) {
  var totalCount = _ref3.totalCount,
    isFollowingOutput = _ref3.isFollowingOutput,
    onFollowOutputChange = _ref3.onFollowOutputChange,
    renderMessage = _ref3.renderMessage,
    computeItemKey = _ref3.computeItemKey,
    listRef = _ref3.listRef,
    bottomInset = _ref3.bottomInset,
    onViewportHeightChange = _ref3.onViewportHeightChange,
    onJumpedToLatest = _ref3.onJumpedToLatest;
  var followingRef = (0, _react.useRef)(isFollowingOutput);
  followingRef.current = isFollowingOutput;
  var insetRef = (0, _react.useRef)(bottomInset);
  insetRef.current = bottomInset;
  var appliedInsetRef = (0, _react.useRef)(bottomInset);
  var lastHeightRef = (0, _react.useRef)(0);
  var _scrollerRef = (0, _react.useRef)(null);
  var followsUnderDrawer = bottomInset > 0;
  (0, _react.useEffect)(function () {
    var scroller = _scrollerRef.current;
    if (scroller === null) return;
    var observer = new ResizeObserver(function () {
      return onViewportHeightChange(scroller.clientHeight);
    });
    observer.observe(scroller);
    return function () {
      return observer.disconnect();
    };
  }, [onViewportHeightChange]);
  var handleTotalListHeightChanged = function handleTotalListHeightChanged(height) {
    var _listRef$current;
    var insetChanged = appliedInsetRef.current !== insetRef.current;
    appliedInsetRef.current = insetRef.current;
    var grewBy = height - lastHeightRef.current;
    lastHeightRef.current = height;
    if (insetRef.current === 0 || insetChanged || grewBy <= 0) return;
    var scroller = _scrollerRef.current;
    if (scroller === null) return;
    var distanceFromEndBeforeGrowth = scroller.scrollHeight - grewBy - (scroller.scrollTop + scroller.clientHeight);
    var stoodAtEnd = distanceFromEndBeforeGrowth <= AT_BOTTOM_THRESHOLD;
    if (followingRef.current || stoodAtEnd) (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo({
      top: scroller.scrollHeight,
      behavior: "auto"
    });
  };
  var jumpToLatestMessage = function jumpToLatestMessage() {
    var _listRef$current2;
    var scroller = _scrollerRef.current;
    if (scroller === null) return;
    (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollTo({
      top: scroller.scrollHeight,
      behavior: "smooth"
    });
    onFollowOutputChange(true);
    onJumpedToLatest();
  };
  var jumpToLatestOverlay = isFollowingOutput ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "absolute inset-x-0",
    style: {
      bottom: bottomInset
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JumpToLatestButton.JumpToLatestButton, {
      onJumpToLatest: jumpToLatestMessage
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "relative flex min-h-0 flex-1 flex-col",
    "data-sentry-component": "VirtualizedMessageList",
    "data-sentry-source-file": "VirtualizedMessageList.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactVirtuoso.Virtuoso, {
      ref: listRef,
      scrollerRef: function scrollerRef(element) {
        _scrollerRef.current = element;
      },
      "data-testid": "chat-message-list",
      totalCount: totalCount,
      context: {
        bottomInset: bottomInset
      },
      followOutput: followsUnderDrawer ? false : function (isAtBottom) {
        if (isFollowingOutput || isAtBottom) return "smooth";
        return false;
      },
      totalListHeightChanged: handleTotalListHeightChanged,
      atBottomStateChange: onFollowOutputChange,
      itemContent: renderMessage,
      computeItemKey: computeItemKey,
      overscan: {
        main: 600,
        reverse: 600
      },
      defaultItemHeight: 80,
      atBottomThreshold: AT_BOTTOM_THRESHOLD,
      increaseViewportBy: {
        top: CARDS_KEPT_DRAWN_BEYOND_VIEW_PX,
        bottom: CARDS_KEPT_DRAWN_BEYOND_VIEW_PX
      },
      style: {
        flexGrow: 1,
        flexBasis: 0
      },
      components: {
        Scroller: Scroller,
        Item: ItemWrapper,
        Footer: Footer
      },
      "data-sentry-element": "Virtuoso",
      "data-sentry-source-file": "VirtualizedMessageList.tsx"
    }), jumpToLatestOverlay]
  });
}
var _default = exports.default = VirtualizedMessageList;